// Action Types
export const ACTION_TYPES = {
    // Navigation
    SET_CURRENT_STEP: 'SET_CURRENT_STEP',
    NEXT_STEP: 'NEXT_STEP',
    PREVIOUS_STEP: 'PREVIOUS_STEP',
    RESET_APP: 'RESET_APP',
    
    // Dining Location
    SET_DINING_LOCATION: 'SET_DINING_LOCATION',
    
    // Restaurant
    SET_RESTAURANT: 'SET_RESTAURANT',
    SET_ALL_RESTAURANTS: 'SET_ALL_RESTAURANTS',
    SET_FILTERED_RESTAURANTS: 'SET_FILTERED_RESTAURANTS',
    SET_SHOW_SUGGESTIONS: 'SET_SHOW_SUGGESTIONS',
    SET_SELECTED_SUGGESTION_INDEX: 'SET_SELECTED_SUGGESTION_INDEX',
    SET_RESTAURANT_NOT_FOUND: 'SET_RESTAURANT_NOT_FOUND',
    
    // Wine Preferences
    SET_WINE_PREFERENCES: 'SET_WINE_PREFERENCES',
    SET_SELECTED_WINE_PREFERENCES: 'SET_SELECTED_WINE_PREFERENCES',
    TOGGLE_WINE_PREFERENCE: 'TOGGLE_WINE_PREFERENCE',
    
    // Food Preferences
    SET_FOOD_CHOICE: 'SET_FOOD_CHOICE',
    SET_SELECTED_FOOD_PREFERENCES: 'SET_SELECTED_FOOD_PREFERENCES',
    TOGGLE_FOOD_PREFERENCE: 'TOGGLE_FOOD_PREFERENCE',
    
    // Price Range
    SET_PRICE_RANGE: 'SET_PRICE_RANGE',
    SET_SELECTED_PRICE_RANGE_LABEL: 'SET_SELECTED_PRICE_RANGE_LABEL',
    
    // Other Info
    SET_OTHER_INFO: 'SET_OTHER_INFO',
    
    // Messages
    SET_CONFIRMATION_MESSAGE: 'SET_CONFIRMATION_MESSAGE',
    
    // Recommendations
    SET_RECOMMENDATIONS: 'SET_RECOMMENDATIONS',
    SET_IS_LOADING_RECOMMENDATIONS: 'SET_IS_LOADING_RECOMMENDATIONS',
    SET_ERROR_FETCHING_RECOMMENDATIONS: 'SET_ERROR_FETCHING_RECOMMENDATIONS',
    
    // Restaurant Summary
    SET_RESTAURANT_SUMMARY: 'SET_RESTAURANT_SUMMARY',
    SET_IS_LOADING_SUMMARIES: 'SET_IS_LOADING_SUMMARIES',
    SET_ERROR_FETCHING_SUMMARIES: 'SET_ERROR_FETCHING_SUMMARIES',

    // Wine Details
    SET_SELECTED_WINE: 'SET_SELECTED_WINE',
    SET_SELECTED_WINE_INFO: 'SET_SELECTED_WINE_INFO',
    SET_IS_LOADING_WINE_INFO: 'SET_IS_LOADING_WINE_INFO',

    // Restaurant Menu
    SET_RESTAURANT_MENU: 'SET_RESTAURANT_MENU',
    SET_IS_LOADING_RESTAURANT_MENU: 'SET_IS_LOADING_RESTAURANT_MENU',
    SET_ERROR_FETCHING_RESTAURANT_MENU: 'SET_ERROR_FETCHING_RESTAURANT_MENU'
};

// Initial State
export const initialState = {
    // Navigation
    currentStep: 1,
    
    // Dining Location
    diningLocation: '', // 'eating_out' or 'eating_in'
    
    // Restaurant
    restaurant: '',
    allRestaurants: [],
    filteredRestaurants: [],
    showSuggestions: false,
    selectedSuggestionIndex: -1,
    restaurantNotFound: false,
    
    // Wine Preferences
    selectedWinePreferences: [],
    winePreferences: '',
    
    // Food Preferences
    foodChoice: '',
    selectedFoodPreferences: [],
    
    // Price Range
    priceRange: '',
    selectedPriceRangeLabel: '',
    
    // Other Info
    otherInfo: '',
    
    // Messages
    confirmationMessage: '',
    
    // Recommendations
    recommendations: [],
    isLoadingRecommendations: false,
    errorFetchingRecommendations: false,
    
    // Restaurant Summary
    restaurantSummary: '',
    isLoadingSummaries: false,
    errorFetchingSummaries: false,

    // Restaurant Menu
    restaurantMenu: null,
    isLoadingRestaurantMenu: false,
    errorFetchingRestaurantMenu: null,

    // Wine Details
    selectedWine: null,
    selectedWineInfo: '',
    isLoadingWineInfo: false
};

// Reducer Function
export const wineAppReducer = (state, action) => {
    switch (action.type) {
        // Navigation
        case ACTION_TYPES.SET_CURRENT_STEP:
            return { ...state, currentStep: action.payload };
            
        case ACTION_TYPES.NEXT_STEP:
            return { ...state, currentStep: state.currentStep + 1 };
            
        case ACTION_TYPES.PREVIOUS_STEP:
            return { ...state, currentStep: Math.max(1, state.currentStep - 1) };
            
        case ACTION_TYPES.RESET_APP:
            return { ...initialState };
            
        // Dining Location
        case ACTION_TYPES.SET_DINING_LOCATION:
            return { ...state, diningLocation: action.payload };
            
        // Restaurant
        case ACTION_TYPES.SET_RESTAURANT:
            return { ...state, restaurant: action.payload };
            
        case ACTION_TYPES.SET_ALL_RESTAURANTS:
            return { ...state, allRestaurants: action.payload };
            
        case ACTION_TYPES.SET_FILTERED_RESTAURANTS:
            return { ...state, filteredRestaurants: action.payload };
            
        case ACTION_TYPES.SET_SHOW_SUGGESTIONS:
            return { ...state, showSuggestions: action.payload };
            
        case ACTION_TYPES.SET_SELECTED_SUGGESTION_INDEX:
            return { ...state, selectedSuggestionIndex: action.payload };
            
        case ACTION_TYPES.SET_RESTAURANT_NOT_FOUND:
            return { ...state, restaurantNotFound: action.payload };
            
        // Wine Preferences
        case ACTION_TYPES.SET_WINE_PREFERENCES:
            return { ...state, winePreferences: action.payload };
            
        case ACTION_TYPES.SET_SELECTED_WINE_PREFERENCES:
            return { ...state, selectedWinePreferences: action.payload };
            
        case ACTION_TYPES.TOGGLE_WINE_PREFERENCE:
            const winePrefs = [...state.selectedWinePreferences];
            const wineIndex = winePrefs.indexOf(action.payload);
            if (wineIndex > -1) {
                winePrefs.splice(wineIndex, 1);
            } else {
                winePrefs.push(action.payload);
            }
            return { ...state, selectedWinePreferences: winePrefs };
            
        // Food Preferences
        case ACTION_TYPES.SET_FOOD_CHOICE:
            return { ...state, foodChoice: action.payload };
            
        case ACTION_TYPES.SET_SELECTED_FOOD_PREFERENCES:
            return { ...state, selectedFoodPreferences: action.payload };
            
        case ACTION_TYPES.TOGGLE_FOOD_PREFERENCE:
            const foodPrefs = [...state.selectedFoodPreferences];
            const foodIndex = foodPrefs.indexOf(action.payload);
            if (foodIndex > -1) {
                foodPrefs.splice(foodIndex, 1);
            } else {
                foodPrefs.push(action.payload);
            }
            return { ...state, selectedFoodPreferences: foodPrefs };
            
        // Price Range
        case ACTION_TYPES.SET_PRICE_RANGE:
            return { ...state, priceRange: action.payload };
            
        case ACTION_TYPES.SET_SELECTED_PRICE_RANGE_LABEL:
            return { ...state, selectedPriceRangeLabel: action.payload };
            
        // Other Info
        case ACTION_TYPES.SET_OTHER_INFO:
            return { ...state, otherInfo: action.payload };
            
        // Messages
        case ACTION_TYPES.SET_CONFIRMATION_MESSAGE:
            return { ...state, confirmationMessage: action.payload };
            
        // Recommendations
        case ACTION_TYPES.SET_RECOMMENDATIONS:
            return { ...state, recommendations: action.payload };
            
        case ACTION_TYPES.SET_IS_LOADING_RECOMMENDATIONS:
            return { ...state, isLoadingRecommendations: action.payload };
            
        case ACTION_TYPES.SET_ERROR_FETCHING_RECOMMENDATIONS:
            return { ...state, errorFetchingRecommendations: action.payload };
            
        // Restaurant Summary
        case ACTION_TYPES.SET_RESTAURANT_SUMMARY:
            return { ...state, restaurantSummary: action.payload };
            
        case ACTION_TYPES.SET_IS_LOADING_SUMMARIES:
            return { ...state, isLoadingSummaries: action.payload };
            
        case ACTION_TYPES.SET_ERROR_FETCHING_SUMMARIES:
            return { ...state, errorFetchingSummaries: action.payload };

        // Restaurant Menu
        case ACTION_TYPES.SET_RESTAURANT_MENU:
            return { ...state, restaurantMenu: action.payload };

        case ACTION_TYPES.SET_IS_LOADING_RESTAURANT_MENU:
            return { ...state, isLoadingRestaurantMenu: action.payload };

        case ACTION_TYPES.SET_ERROR_FETCHING_RESTAURANT_MENU:
            return { ...state, errorFetchingRestaurantMenu: action.payload };

        // Wine Details
        case ACTION_TYPES.SET_SELECTED_WINE:
            return { ...state, selectedWine: action.payload };
            
        case ACTION_TYPES.SET_SELECTED_WINE_INFO:
            return { ...state, selectedWineInfo: action.payload };
            
        case ACTION_TYPES.SET_IS_LOADING_WINE_INFO:
            return { ...state, isLoadingWineInfo: action.payload };
            
        default:
            return state;
    }
};
